import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const PricingPolicy = () => {
  return (
    <div className="container px-4 pt-5 mt-5">
      <h2 className="text-3xl font-bold text-gray-800 mb-4">Pricing Policy</h2>
      <p className="text-gray-600 mb-4">
        At <strong>RUSH EZ Valet Parking System</strong>, we make tipping valets{" "}
        <strong>easy, secure, and convenient</strong> through our{" "}
        <strong>Digital Valet Tipping</strong> feature. Our transparent pricing
        ensures a seamless experience for both businesses and valets.
      </p>

      <h5>Transaction Fee & Commission</h5>
      <ul className="list-disc pl-5 text-gray-600 mt-2">
        <li>
          A <strong>10% service fee</strong> is deducted from each digital tip.
        </li>
        <li>
          The remaining <strong>90%</strong> is automatically credited to the
          valet’s bank account.
        </li>
      </ul>

      <h5>Payout & Settlement</h5>
      <ul className="list-disc pl-5 text-gray-600 mt-2">
        <li>
          <strong>Daily automatic settlements</strong>: All collected tips are
          transferred to valets at the end of each day.
        </li>
        <li>
          <strong>Secure transactions</strong> ensure reliability and speed.
        </li>
      </ul>

      <h5>Additional Charges</h5>
      <ul className="list-disc pl-5 text-gray-600 mt-2">
        <li>
          <strong>No hidden fees</strong> – we maintain full transparency.
        </li>
        <li>
          Standard <strong>payment gateway charges</strong> may apply based on
          the transaction method.
        </li>
        <li>
          <strong>₹20 per parking </strong>is charged to the customer.
        </li>
      </ul>

      {/* Contact Information */}
      <div className="mt-6 p-4 bg-blue-50 border-l-4 border-blue-500">
        <p className="text-gray-800 font-medium">
          📞 <strong>Contact Us:</strong>{" "}
          <a href="tel:+919490432904" className="text-blue-500 hover:underline">
            +91 9490432904
          </a>
        </p>
        <p className="text-gray-800 font-medium">
          📩 <strong>Email:</strong>{" "}
          <a
            href="mailto:support@gorush.co"
            className="text-blue-500 hover:underline"
          >
            support@gorush.co
          </a>
        </p>
      </div>
    </div>
  );
};

export default PricingPolicy;
